
    <div class="root-notifications">
      <ng-content></ng-content>
    </div>
  